var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExercise = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.414 6.05c2.924-2.923 7.277-3.065 9.846-.057 1.97 2.304 2.269 5.24.32 9.007h2.17c1.866-4.126 1.407-7.525-.969-10.306C25.408.745 19.705.93 16 4.636 12.293.93 6.439.741 3.204 4.712.912 7.525.467 10.912 2.294 15H4.46c-1.912-3.74-1.618-6.677.295-9.025 2.434-2.988 6.913-2.843 9.832.075l.707.707a1 1 0 0 0 1.414 0l.707-.707Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M30.5 17a1 1 0 1 1 0 2h-3.134c-2.33 3.206-5.861 6.785-10.732 10.774a1 1 0 0 1-1.268 0C10.493 25.783 6.973 22.206 4.656 19H1a1 1 0 1 1 0-2h8.68l1.34-6.696a1 1 0 0 1 1.929-.12l3.286 9.859 3.393-6.033a1 1 0 0 1 1.74-.006L23.08 17zm-5.597 2H22.5a1 1 0 0 1-.868-.504l-1.125-1.968-3.635 6.462a1 1 0 0 1-1.82-.174l-2.81-8.427-.761 3.807a1 1 0 0 1-.98.804H7.114c2.06 2.572 4.98 5.458 8.885 8.704 3.905-3.245 6.832-6.133 8.903-8.704Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})))));
export default SvgExercise;